import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { firTrasmissioneRowFields, type FirRecord } from "@/lib/fir";

export function FirTrasmissioneDettaglioDialog({
  trasmissione,
  open,
  onOpenChange,
  onApriFir,
}: {
  trasmissione: FirRecord | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onApriFir?: (numeroFir: string) => void;
}) {
  if (!trasmissione) return null;
  const row = firTrasmissioneRowFields(trasmissione);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg gap-4">
        <DialogHeader>
          <DialogTitle className="text-base">Dettaglio invio dati FIR digitale</DialogTitle>
          <DialogDescription className="sr-only">
            Esito e metadati della trasmissione FIR verso RENTRI per l&apos;identificativo indicato.
          </DialogDescription>
          <Badge variant="outline" className="w-fit font-mono text-xs font-normal">
            {row.identificativo}
          </Badge>
        </DialogHeader>

        <dl className="grid gap-3 text-sm">
          <div>
            <dt className="text-xs text-muted-foreground">Data trasmissione</dt>
            <dd className="font-medium">{row.dataTrasmissione}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Tipo trasmissione</dt>
            <dd>
              <Badge variant="secondary">{row.tipo}</Badge>
            </dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Utente</dt>
            <dd className="font-mono text-xs">{row.utente}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Numero FIR</dt>
            <dd className="font-mono text-xs">{row.numeroFir}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Data emissione FIR</dt>
            <dd>{row.dataEmissione}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Codice EER</dt>
            <dd className="font-mono">{row.eer}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Quantità</dt>
            <dd>{row.quantita}</dd>
          </div>
          <div>
            <dt className="text-xs text-muted-foreground">Stato</dt>
            <dd>
              <Badge variant={row.stato === "Attivo" ? "success" : "outline"}>{row.stato}</Badge>
            </dd>
          </div>
        </dl>

        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-end">
          {onApriFir && row.numeroFir !== "—" && (
            <Button type="button" variant="default" onClick={() => onApriFir(row.numeroFir)}>
              Informazioni FIR
            </Button>
          )}
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Chiudi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
